import NxsObserver, { trackers } from '@rmm/error-tracker';

const initLoggerForAmp = () => {
  if (window.loggingSettings && window.loggingSettings.enable) {
    const IS_LOGGING_ONLY_LEAD_MEDIA = window.loggingSettings?.onlyLeadMedia;
    const defaultLoggingParams = {
      id: IS_LOGGING_ONLY_LEAD_MEDIA ? 'player-lead-media' : 'general-task',
      position: IS_LOGGING_ONLY_LEAD_MEDIA ? 'Lead Media' : 'general-task',
      renderGroup: 'Initialization within WP',
    };

    const { SimpleErrorTracker } = trackers;
    window.errorTracker = NxsObserver;
    window.errorTrackerInstance = NxsObserver.getInstance(
      window.loggingSettings,
    );

    const heartbeatTracker = new SimpleErrorTracker(
      'Heartbeat',
      100,
      defaultLoggingParams,
    );
    const selector = `script.${window.loggingSettings.settingsScriptHandle}`;
    const settingsScriptNode = document.querySelector(selector);
    if (settingsScriptNode && 'true' === settingsScriptNode.dataset.pixelHit) {
      heartbeatTracker.sendSuccess();
    } else {
      heartbeatTracker.sendError(new Error('Heartbeat pixel not hit'), 1);
    }

    const ampTracker = new SimpleErrorTracker(
      'Heartbeat: AMP page',
      100,
      defaultLoggingParams,
    );
    ampTracker.sendSuccess();
  }
  window.trackerReady = true;
};

export default initLoggerForAmp;
